import React from 'react';
import { Button, Col, Image, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getNotificationNumber } from '../../../../shared/functions/Functions';
import { IOfferManagementFilter } from '../dto/IOfferManagementFilter';
import { InternalRoutes } from '../../../../enum/InternalRoutes';
import { BiGift } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../store/rootReducer';
import { SearchInput } from '../../../../shared/components/SearchInput';

interface IFilterModalProps {
    show: boolean;
    closeModal: () => void;
    onSearch: (value: string) => void;
    statusBarterHandle: () => void;
    statusContractHandle: () => void;
    offerFilter: IOfferManagementFilter;
    isAgency?: boolean;
    isFilterLoading?: boolean;
}

export function OffersFilterModal({
    show,
    closeModal,
    statusBarterHandle,
    onSearch,
    offerFilter,
    isAgency,
    statusContractHandle,
    isFilterLoading = false,
}: IFilterModalProps) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { redDots } = useSelector((state: IAllStates) => state.redDots);
    const loadingClass = isFilterLoading ? 'opacity-50' : '';

    return (
        <Modal centered show={show} onHide={closeModal}>
            <Modal.Body>
                <Row style={{ gap: 12 }}>
                    <Col>
                        <div className="d-flex align-items-center mb-3">
                            <Image src="/icons/settings-sliders-gray.svg" alt="filter icon" />
                            <h6 className="mb-0 ml-2">{t('influencer.offer_management.filters')}</h6>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <SearchInput
                            name="title"
                            defaultValue={offerFilter?.name ?? ''}
                            onSearch={onSearch}
                            isLoading={isFilterLoading}
                            label={t('general.button.search')}
                        />
                    </Col>
                    <Col md={6}>
                        <div
                            onClick={statusBarterHandle}
                            className={`influencer-tab-filter primary-dark position-relative ${
                                offerFilter?.isCharity ? 'active' : ''
                            } ${loadingClass}`}
                        >
                            <BiGift size={18} />
                            <span className="ml-1">
                                {!offerFilter?.isCharity
                                    ? t('influencer.explore.barter')
                                    : t('influencer.explore.paid')}
                            </span>
                            {!offerFilter?.isCharity
                                ? !!getNotificationNumber('barterOffers', redDots) && (
                                      <span className="sidebar-bullet">
                                          {getNotificationNumber('barterOffers', redDots)}
                                      </span>
                                  )
                                : !!getNotificationNumber('paidOffers', redDots) && (
                                      <span className="sidebar-bullet">
                                          {getNotificationNumber('paidOffers', redDots)}
                                      </span>
                                  )}
                        </div>
                    </Col>
                    <Col md={6}>
                        <div
                            onClick={statusContractHandle}
                            className={`influencer-tab-filter primary ml-md-3 my-md-0 position-relative ${
                                offerFilter?.isContract ? 'active' : ''
                            } ${loadingClass}`}
                        >
                            {t('brand.campaign.book.offer.filters.long_term')}
                        </div>
                    </Col>
                    <Col md={6}>
                        <Button
                            onClick={() =>
                                navigate(isAgency ? InternalRoutes.AGENCY_DECLINED_OFFER : '/influencer/offer/declined')
                            }
                            variant="outline-danger"
                            className="w-100"
                        >
                            {t('brand.campaign.book.offer.filters.declined')}
                        </Button>
                    </Col>
                    <Col xs={12} className="d-flex justify-content-between mt-5">
                        <Button variant="outline-primary" size="sm" onClick={closeModal}>
                            {t('general.button.cancel')}
                        </Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}
